import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Grid, Box } from '@material-ui/core';
import FormikInput from 'src/components/formik/FormikInput';
import * as actions from 'src/redux/actions';
import Alert from '@material-ui/lab/Alert';
import FormikForm from '../../../components/formik/FormikForm';

const INITIAL_VALUES = {
  email: '',
  password: ''
};

const VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
  password: Yup.string().max(255).required('Password is required')
});

type SignInFormProps = {
    signIn?: (...args: any[]) => any;
    isVerified?: boolean;
};

function SignInForm({ signIn, isVerified }: SignInFormProps) {
  return (
    <FormikForm
      initialValues={INITIAL_VALUES}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={signIn}
      primarySubmit
    >
      {
        isVerified && (
          <Grid item xs={12}>
            <Alert severity="success">
              Your email has been verified.
            </Alert>
          </Grid>
        )
      }
      <Grid item xs={12}>
        <Box mt={2}>
          <FormikInput
            fullWidth
            autoFocus
            label="Email address"
            name="email"
            type="email"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <FormikInput
          fullWidth
          label="Password"
          name="password"
          type="password"
        />
      </Grid>
    </FormikForm>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  signIn: (payload: any, formActions: any) => dispatch(actions.signIn(payload, formActions))
});

export default connect(null, mapDispatchToProps)(SignInForm);
